export default "__VITE_ASSET__DAvvDKoC__"